import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import './permission'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/style/index.scss'
import vue3SeamlessScroll from "vue3-seamless-scroll"

import ElTableInfiniteScroll from "el-table-infinite-scroll";
// import './assets/icons'

import SvgIcon from './views/components/svgIcon/index.vue'
// import './assets/icons/svg'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
const debounce = (fn, delay) => {
  let timer: number;
  return function () {
    let context = this;
    let args = arguments;
    if(timer) {
      clearTimeout(timer);
    }
    timer = window.setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}

app
  .use(ElementPlus)
  .use(store)
  .use(PerfectScrollbar)
  .use(router)
  // @ts-ignore
  .use(ElTableInfiniteScroll)
  .use(vue3SeamlessScroll, { name: 'vue3-seamless-scroll' })
  .component('svg-icon', SvgIcon)
  .mount('#app')

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context('./assets/svg', false, /\.svg$/);
requireAll(req);
